<template>
  <div id="app" :class="{logged_in: $auth.check()}">
    <div v-if="env === 'staging'" class="env">FINEテスト環境</div>
    <Navigator v-if="$auth.check()"/>

    <Init v-if="$auth.check()"/>

    <main>
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
import Navigator from '@/components/navigator'
import Init from '@/components/init'

export default {
  name: 'app',
  components: {
    Navigator,
    Init
  },
  computed: {
    env: function () {
      return process.env.NODE_ENV
    }
  },
  mounted () {
    if (this.env === 'staging') {
      document.title = 'FINEテスト環境'
    }
  }
}
</script>

<style lang="scss">
@import "sass/main.scss";

body {
  margin: 0;
}

* {
  box-sizing: border-box;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  position: relative;
}

#app.logged_in {
  padding-top: 62px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue